import { argon2id } from "hash-wasm";

export interface KdfParams {
  memory: number;
  iterations: number;
  parallelism: number;
  hashLength: number;
}

export const DEFAULT_KDF_PARAMS: KdfParams = {
  memory: 65536, // 64 MB
  iterations: 3,
  parallelism: 4,
  hashLength: 32, // 256 bits for AES-256
};

/**
 * Derive a cryptographic key from a passcode using Argon2id
 */
export async function deriveKey(
  passcode: string,
  salt: Uint8Array,
  params: KdfParams = DEFAULT_KDF_PARAMS,
): Promise<Uint8Array> {
  const hashHex = await argon2id({
    password: passcode,
    salt,
    memorySize: params.memory,
    iterations: params.iterations,
    parallelism: params.parallelism,
    hashLength: params.hashLength,
    outputType: "hex",
  });

  // Convert hex to Uint8Array
  const bytes = new Uint8Array(hashHex.length / 2);
  for (let i = 0; i < hashHex.length; i += 2) {
    bytes[i / 2] = parseInt(hashHex.substring(i, i + 2), 16);
  }
  return bytes;
}

/**
 * Generate a random salt for key derivation
 */
export function generateSalt(): Uint8Array {
  const salt = new Uint8Array(16);
  crypto.getRandomValues(salt);
  return salt;
}

/**
 * Serialize KDF params to string
 */
export function serializeKdfParams(params: KdfParams): string {
  return JSON.stringify(params);
}

/**
 * Parse KDF params from string
 */
export function parseKdfParams(str: string): KdfParams {
  return JSON.parse(str) as KdfParams;
}
